const Avatar = {}
// Pour la customisation de l'avatar j'ai préféré le custom dans 'components/ui' car l'effet pour rendre l'avatar carré n'était urilisable que sur la balise <Avatar></Avatar>, la aussi je me suis cassé les dents quelques temps mais ça gère de fou comme j'ai fais
export default Avatar
